import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, makeStyles, Typography } from "@material-ui/core";
import AssessmentIcon from "@material-ui/icons/Assessment";
import FilterListIcon from "@material-ui/icons/FilterList";
import HelpIcon from "@material-ui/icons/Help";
import TableChartIcon from "@material-ui/icons/TableChart";

import HeaderPageItem from "../../../../../custom/HeaderPageItem";
import ActionDialog from "../../../ActionDialog";
import HelpItemsList from "../../HelpDialog/HelpItemsList";
import SectionTitle from "../../HelpDialog/SectionTitle";
import TableActionsHelp from "../../HelpDialog/TableActionHelp";
import TipBox from "../../../TipBox";

const useClasses = makeStyles((theme) => ({
  section: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
  },
}));

const summaryItems = [
  "app.report.contract.help.summary.contractCount",
  "app.report.contract.help.summary.custodiedAmount",
  "app.report.contract.help.summary.totalYield",
  "app.report.contract.help.summary.firstOpenDate",
  "app.report.contract.help.summary.lastDueDate",
];

const HeaderWithHelpDialog = () => {
  const classes = useClasses();
  const [openDialog, setOpenDialog] = React.useState(false);

  const filters = [
    "app.report.contract.byCustomer.filter.situations",
    "app.report.contract.byCustomer.filter.modalities",
    "app.report.contract.byCustomer.filter.durations",
    "app.report.contract.byCustomer.filter.dateColumn",
    "app.report.contract.byCustomer.filter.datePeriod",
  ];

  return (
    <>
      <HeaderPageItem
        useHistoryGoBack
        showBackButton
        title="app.report.contract.allBelow"
        onMore={() => setOpenDialog(true)}
        IconMore={HelpIcon}
      />

      <ActionDialog
        open={openDialog}
        title="app.report.contract.allBelow"
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        textButtonCancel="app.close"
        enableConfirmButton={false}
      >
        {/* descrição */}
        <Box className={classes.section}>
          <Typography variant="body1" paragraph>
            <FormattedMessage id="app.report.contract.allBelow.description1" />
          </Typography>
          <Typography variant="body1" paragraph>
            <FormattedMessage id="app.report.contract.allBelow.description2" />
          </Typography>
          <Typography variant="body1" paragraph>
            <FormattedMessage id="app.report.contract.allBelow.description3" />
          </Typography>
        </Box>

        {/* filtros */}
        <Box className={classes.section}>
          <SectionTitle icon={FilterListIcon}>
            <FormattedMessage id="app.filters" />
          </SectionTitle>
          <HelpItemsList messages={filters} />
        </Box>

        {/* resumo */}
        <Box className={classes.section}>
          <SectionTitle icon={AssessmentIcon}>
            <FormattedMessage id="app.report.contract.help.summary" />
          </SectionTitle>
          <Typography variant="body1" paragraph>
            <FormattedMessage id="app.report.contract.help.summary.description" />
          </Typography>
          <HelpItemsList messages={summaryItems} />
        </Box>

        {/* tabela */}
        <Box className={classes.section}>
          <SectionTitle icon={TableChartIcon}>
            <FormattedMessage id="app.report.contract.help.table" />
          </SectionTitle>
          <Typography variant="body1" paragraph>
            <FormattedMessage id="app.report.contract.help.table.description1" />
          </Typography>
          <TipBox>
            <FormattedMessage id="app.report.contract.help.table.commissions.alert" />
          </TipBox>
          <TipBox>
            <FormattedMessage id="app.report.contract.help.table.tip" />
          </TipBox>
        </Box>

        {/* ações extras da tabela */}
        <TableActionsHelp showCopy showColumns showHeaderClick />
      </ActionDialog>
    </>
  );
};

export default HeaderWithHelpDialog;
